import { FC, Suspense } from "react";

import { QueryErrorResetBoundary } from "@tanstack/react-query";

import * as Sentry from "@sentry/react";

import ActiveProcedureItem from "@/components/Procedures/ActiveProcedureItem";

import ComponentError from "@/helpers/components/Errors/Components";
import PaginatedSearchWrapper from "@/helpers/components/PaginatedSearchWrapper";
import ActiveItemTableSkeleton from "@/helpers/components/Skeletons/ActiveItemTableSkeleton";

import { useFetchActiveProcedures } from "@/service/ProcedureQueries";

export const ActiveProcedureDesign: FC = () => {
	const { data: procedures } = useFetchActiveProcedures();

	return (
		<>
			<QueryErrorResetBoundary>
				{({ reset }) => (
					<Sentry.ErrorBoundary
						onReset={reset}
						fallback={({ error, resetError }) => (
							<ComponentError message={error.message} reset={resetError} />
						)}
					>
						<Suspense fallback={<ActiveItemTableSkeleton />}>
							<PaginatedSearchWrapper
								items={procedures}
								itemsPerPage={8}
								initialSortOrder="DESC"
								getItemName={(item) => item.Name}
								getItemDate={(item) => item.LastModified}
							>
								{(paginatedItems) =>
									paginatedItems?.map((item, key) => {
										return <ActiveProcedureItem item={item} key={key} />;
									})
								}
							</PaginatedSearchWrapper>
						</Suspense>
					</Sentry.ErrorBoundary>
				)}
			</QueryErrorResetBoundary>
		</>
	);
};
